<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="2vh"
        :title="editInfoPlus"
        custom-class="update-employee-plus-dialog sk-dialog"
    >
      <el-form
          label-width="140px"
          :model="formAllTabEmployee"
          label-position="left"
          :rules="rules"
          ref="formAllTabEmployee"
          class="update-employee-plus-form"
      >
        <div class="update-employee-plus-content">
          <div class="employee-plus-panel">
            <el-tabs class="update-employee-plus-tabs" type="card" v-model="activeTabName">
          <el-tab-pane label="Thông tin" name="infoTab">
            <div class="common-info-tab">
              <el-row :gutter="24">
                <!-- Column 1: Profile Summary, status & QR -->
                <el-col :span="6">
                  <div class="profile-sidebar-card">
                    <!-- Avatar Area -->
                    <div class="profile-avatar-wrap">
                      <el-image
                          v-if="(formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView && showPicutreInitial) || imageUrlPreview"
                          class="profile-avatar"
                          :src="imageUrlPreview ? imageUrlPreview : formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView"
                          fit="cover"
                      ></el-image>
                      
                      <!-- Hidden upload trigger -->
                      <el-upload
                          :show-file-list="false"
                          :on-change="toggleUpload"
                          :on-remove="handleRemove"
                          :auto-upload="false"
                          style="display: none;"
                          ref="upload"
                          action=""
                      >
                      </el-upload>
                      
                      <!-- Click-to-add Area if empty -->
                      <div 
                          v-if="!((formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView && showPicutreInitial) || imageUrlPreview)"
                          class="avatar-trigger-area"
                          @click="triggerAvatarUpload"
                      >
                        <i class="el-icon-plus"></i>
                        <span>Thêm ảnh đại diện</span>
                      </div>
                      
                      <!-- Hover edit/delete overlay if image exists -->
                      <div 
                          v-else
                          class="avatar-actions-overlay"
                      >
                        <button type="button" class="avatar-action-btn edit-btn" @click="triggerAvatarUpload" title="Thay đổi ảnh">
                          <i class="el-icon-edit-outline"></i>
                        </button>
                        <button type="button" class="avatar-action-btn delete-btn" @click="handleRemove" title="Xóa ảnh">
                          <i class="el-icon-delete"></i>
                        </button>
                      </div>
                    </div>

                    <!-- QR Bank Card Area -->
                    <div class="qr-bank-section">
                      <div class="section-divider">Ảnh QR ngân hàng</div>
                      <div class="qr-container-wrap">
                        <el-image
                            v-if="(formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb && showPicutreInitial) || qrUrlPreview"
                            class="qr-bank-image"
                            :src="qrUrlPreview ? qrUrlPreview : formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb"
                            fit="contain"
                        ></el-image>
                        
                        <!-- Hidden upload trigger for QR -->
                        <el-upload
                            :show-file-list="false"
                            :on-change="toggleUploadQr"
                            :on-remove="handleRemoveQr"
                            :auto-upload="false"
                            style="display: none;"
                            ref="uploadQrBank"
                            action=""
                        >
                        </el-upload>

                        <!-- Click-to-add Area if empty -->
                        <div 
                            v-if="!((formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb && showPicutreInitial) || qrUrlPreview)"
                            class="qr-trigger-area"
                            @click="triggerQrUpload"
                        >
                          <i class="el-icon-plus"></i>
                          <span>Thêm QR</span>
                        </div>
                        
                        <!-- Hover edit/delete overlay if QR exists -->
                        <div 
                            v-else
                            class="qr-actions-overlay"
                        >
                          <button type="button" class="avatar-action-btn edit-btn" @click="triggerQrUpload" title="Thay đổi QR">
                            <i class="el-icon-edit-outline"></i>
                          </button>
                          <button type="button" class="avatar-action-btn delete-btn" @click="handleRemoveQr" title="Xóa QR">
                            <i class="el-icon-delete"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Employee Code Badge -->
                    <div class="profile-code-section">
                      <span class="profile-code-label">Mã nhân sự</span>
                      <div class="profile-code-value">{{ formAllTabEmployee.updateEmployeeMainInfoRequest.code }}</div>
                    </div>

                    <!-- Status Area -->
                    <div class="profile-status-section">
                      <div class="section-divider">Trạng thái làm việc</div>
                      <el-radio-group
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus"
                          class="status-radio-group"
                      >
                        <el-radio-button label="Đang làm">Đang làm</el-radio-button>
                        <el-radio-button label="Tạm nghỉ">Tạm nghỉ</el-radio-button>
                        <el-radio-button label="Nghỉ làm">Nghỉ làm</el-radio-button>
                      </el-radio-group>
                      
                      <!-- Status datepickers styled beautifully -->
                      <transition name="el-zoom-in-top">
                        <div class="status-date-wrap" v-if="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Tạm nghỉ' || formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Nghỉ làm'">
                          <el-form-item
                              prop="updateEmployeeMainInfoRequest.dateRetain"
                              v-if="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Tạm nghỉ'"
                              label="Ngày tạm nghỉ"
                          >
                            <el-date-picker
                                style="width: 100%"
                                type="date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Chọn ngày"
                                v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.dateRetain"
                            ></el-date-picker>
                          </el-form-item>

                          <el-form-item
                              prop="updateEmployeeMainInfoRequest.dateLeave"
                              v-if="formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus == 'Nghỉ làm'"
                              label="Ngày nghỉ làm"
                          >
                            <el-date-picker
                                style="width: 100%"
                                v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.dateLeave"
                                type="date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Chọn ngày"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </transition>
                    </div>
                  </div>
                </el-col>

                <!-- Column 2: Personal Information Grid -->
                <el-col :span="9">
                  <div class="info-section-card">
                    <div class="card-inner-title"><i class="el-icon-user"></i> Thông tin nhân sự</div>
                    
                    <el-form-item label="Họ tên" prop="updateEmployeeMainInfoRequest.fullName">
                      <el-input
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.fullName"
                      ></el-input>
                    </el-form-item>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Số điện thoại" prop="updateEmployeeMainInfoRequest.phone">
                          <el-input
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.phone"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="updateEmployeeMainInfoRequest.gender" label="Giới tính">
                          <el-radio-group
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.gender"
                              class="gender-radio-group"
                          >
                            <el-radio-button label="Nam">Nam</el-radio-button>
                            <el-radio-button label="Nữ">Nữ</el-radio-button>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày sinh" prop="updateEmployeeMainInfoRequest.birthday">
                          <el-date-picker
                              :clearable="false"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.birthday"
                              format="dd-MM-yyyy"
                              :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày sinh"
                              style="width: 100%"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Dân tộc" prop="updateEmployeeMainInfoRequest.ethnic">
                          <el-input
                              clearable
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.ethnic"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item label="Email" prop="updateEmployeeMainInfoRequest.email">
                      <el-input
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.email"
                      ></el-input>
                    </el-form-item>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item prop="updateEmployeeMainInfoRequest.cmnd">
                          <span slot="label">
                            Số định danh
                            <el-tooltip class="item" effect="dark" content="Số định danh của nhân sự" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </span>
                          <el-input
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.cmnd"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Ngày cấp" prop="updateEmployeeMainInfoRequest.cmndDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.cmndDate"
                              style="width: 100%"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày cấp"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <div class="section-divider" style="margin: 16px 0 12px;">Tài khoản nhận lương</div>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngân hàng">
                          <el-input
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.nameBank"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Số tài khoản">
                          <el-input
                              type="number"
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.bankAccountNumber"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>

                <!-- Column 3: Work & Other Details -->
                <el-col :span="9">
                  <div class="info-section-card parent-card">
                    <div class="card-inner-title"><i class="el-icon-suitcase-1"></i> Thông tin công việc & Hôn nhân</div>
                    
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày vào" prop="updateEmployeeMainInfoRequest.startDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.startDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Chọn ngày vào"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Ngày ký hợp đồng" prop="updateEmployeeMainInfoRequest.contractDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.contractDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Chọn ngày"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày hết hạn" prop="updateEmployeeMainInfoRequest.endDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.endDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Ngày hết hạn"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Trình độ" prop="updateEmployeeMainInfoRequest.educationLevel">
                          <el-input
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.educationLevel"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Đối tượng" prop="updateEmployeeMainInfoRequest.idAccountTypeList">
                          <el-select
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.idAccountTypeList"
                              multiple
                              placeholder="Chọn đối tượng"
                              clearable
                              style="width: 100%"
                              filterable
                          >
                            <el-option
                                v-for="item in accountTypeList"
                                :key="item.id"
                                :value="item.id"
                                :label="item.name"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Hôn nhân" prop="updateEmployeeMainInfoRequest.marriedStatus">
                          <el-select
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.marriedStatus"
                              filterable
                              clearable
                              style="width: 100%"
                          >
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="24">
                        <el-form-item label="Số con" prop="updateEmployeeMainInfoRequest.numberChildren">
                          <el-input
                              v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.numberChildren"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item label="Địa chỉ thường trú" prop="updateEmployeeMainInfoRequest.permanentAddress">
                      <el-input
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.permanentAddress"
                      ></el-input>
                    </el-form-item>
                    
                    <el-form-item label="Chỗ ở hiện tại" prop="updateEmployeeMainInfoRequest.address">
                      <el-input
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.address"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="Ghi chú" prop="updateEmployeeMainInfoRequest.note">
                      <el-input
                          v-model="formAllTabEmployee.updateEmployeeMainInfoRequest.note"
                          type="textarea"
                          :rows="1"
                          style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="App Plus">
            <!-- table 1 -->
            <el-table
                class="table-icon-1"
                border
                :data="plusIconAppUpdate.plusIconUpdate1"
                highlight-current-row
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeight"
            >
              <el-table-column width="50" type="index" label="STT" align="center"></el-table-column>
              <el-table-column prop="iconName" min-width="130" label="Chức năng"></el-table-column>
              <el-table-column label="Hiển thị" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Mở khóa" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                      v-if="scope.row.rootLockStatus"
                      v-model="scope.row.status"
                  ></el-checkbox>
                  <el-checkbox v-else disabled></el-checkbox>
                </template>
              </el-table-column>
            </el-table>

            <!-- table 2 -->
            <el-table
                class="table-icon-2"
                border
                :data="plusIconAppUpdate.plusIconUpdate2"
                highlight-current-row
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeight"
            >
              <el-table-column width="50" type="index" label="STT" align="center"></el-table-column>
              <el-table-column prop="iconName" min-width="130" label="Chức năng"></el-table-column>
              <el-table-column label="Hiển thị" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Mở khóa" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                      v-if="scope.row.rootLockStatus"
                      v-model="scope.row.status"
                  ></el-checkbox>
                  <el-checkbox v-else disabled></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="Chức năng App Plus">
            <!-- table 1 -->
            <el-table
                class="table-icon-1"
                border
                :data="listAppPlusConfig"
                highlight-current-row
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeight"
            >
              <el-table-column width="50" type="index" label="STT" align="center"></el-table-column>
              <el-table-column prop="name" min-width="130" label="Chức năng"></el-table-column>
              <el-table-column label="Hoạt động" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.showConfig" @change="handleChangePlusConfig(scope.row)" ></el-checkbox>
                </template>
              </el-table-column>
            </el-table>

          </el-tab-pane>
          <el-tab-pane label="Cấu hình Cam" name="commonConfig" v-if="showButtonClick">
            <el-row>
              <el-col :offset="7">
                <el-table
                    style="width: 700px; margin-top: 10px"
                    ref="multipleTable"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255,255,255, 0)"
                    :data="plusCamList"
                    highlight-current-row
                    :header-cell-style="tableHeaderColor"
                    border
                >
                  <el-table-column
                      type="index"
                      label="STT"
                      width="50"
                      align="center"
                  ></el-table-column>
                  <el-table-column prop="cameraName" label="Tên cam"></el-table-column>
                  <el-table-column prop="description" label="Trạng thái" width="100px" align="center">
                    <template slot-scope="scope">
                      <div class="checkbox-container">
                        <el-checkbox v-model="scope.row.active"></el-checkbox>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="Tác vụ"
                      width="120"
                      align="center"
                  >
                    <template slot-scope="scope">
                      <el-button
                          :disabled="!scope.row.active"
                          size="mini"
                          type="success"
                          @click="handleSettingCame(scope.row)"
                      >Thiết lập
                      </el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-form>
      <div class="tab-infor-button update-employee-plus-footer" v-if="showButtonClick">
        <el-button
            class="btn-cancel"
            type="danger"
            size="medium"
            @click="closeDialogByButton('formAllTabEmployee')"
        >
          <i class="el-icon-circle-close"/>
          <span>Đóng</span>
        </el-button>
        <el-button
            class="btn-save"
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm('formAllTabEmployee')"
        >
          <i class="el-icon-circle-check"/>
          <span>Lưu</span>
        </el-button>
      </div>
    </el-dialog>
    <CamSettingPlusDialog
        :showSettingCamera="showSettingCamera"
        :idPlus="idPlus"
        :idCamera="idCamera"
        :cameraName="cameraName"
        @close="handleCloseSettingCameraDialog"
    />
  </div>
</template>

<script>
import EmployeeDataService from "@/services/EmployeeService/EmployeeDataService";
import SupperPlusService from "@/services/SupperPlusService";

import CamSettingPlusDialog from "@/views/employee/CamSettingPlusDialog";
import StudentService from "@/services/StudentService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  components: {CamSettingPlusDialog},
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      editInfoPlus:'Sửa thông tin plus',
      plusCamList: [],
      comparePlusCamList: [],
      idPlus: 0,
      idCamera: 0,
      cameraName: "",
      showSettingCamera: false,
      checkAppType: "",
      showPicutreInitial: true,
      fileList: [],
      fileQrList: [],
      dialogImageUrl: "",
      dialogVisible1: false,
      fileAvatar: "",
      fileQrBank: null,
      showUpload: true,
      showUploadQr: true,
      imageUrlPreview: "",
      qrUrlPreview: "",
      avatar: {},
      isMasterAccountType: true,
      idEmployeeEdit: "",
      accountTypeList: [],
      showButtonClick: true,
      value: "",
      radiogender: "",
      options: [
        {
          value: "Độc thân",
          label: "Độc thân",
        },
        {
          value: "Đã kết hôn",
          label: "Đã kết hôn",
        },
      ],
      teacherIconAppUpdate: {
        teacherIconUpdate1: [],
        teacherIconUpdate2: [],
      },
      plusIconAppUpdate: {
        plusIconUpdate1: [],
        plusIconUpdate2: [],
      },
      notifyPlusIconAppUpdate: {
        notifyPlusIconUpdate1: [],
        notifyPlusIconUpdate2: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      loadingButton: false,
      formAllTabEmployee: {
        updateEmployeeMainInfoRequest: {
          id: "",
          idAccountTypeList: [],
          fullName: "",
          birthday: "",
          address: "",
          gender: "",
          email: "",
          phone: "",
          cmnd: "",
          cmndDate: "",
          permanentAddress: "",
          marriedStatus: "",
          numberChildren: "",
          educationLevel: "",
          startDate: "",
          contractDate: "",
          endDate: "",
          employeeStatus: "",
          note: "",
          dateLeave: "",
          dateRetain: "",
          avatar: "",
          avatarView: "",
          nameBank: "",
          bankAccountNumber: "",
          qrCodeWeb: "",
          imgBank: "",
        },
        tabDepartmentInEmployee: [],
        tabDepartmentRequestList: [],
        tabProfessionalInEmployee: [],
        tabProfessionalRequestList: [],
        notifyAppIconPlusRequestList: [],
        idSchool: "",
      },
      activeTabName: "infoTab",
      rules: {
        updateEmployeeMainInfoRequest: {
          fullName: [
            {
              required: true,
              message: "Họ tên không được để trống",
              trigger: "blur",
            },
          ],
          phone: [
            {
              required: true,
              message: "Số điện thoại không được để trống",
              trigger: "change",
            },
            {
              min: 10,
              max: 10,
              message: "Số điện thoại bao gồm 10 số",
              trigger: "change",
            },
          ],
          gender: [
            {
              required: true,
              message: "Giới tính không được để trống",
              trigger: "blur",
            },
          ],
          startDate: [
            {
              required: true,
              message: "Ngày vào không được để trống",
              trigger: "blur",
            },
          ],
          birthday: [
            {
              required: true,
              message: "Giới tính không được để trống",
              trigger: "blur",
            },
          ],
          dateLeave: [
            {
              required: true,
              message: "Ngày nghỉ làm không được để trống",
              trigger: "change",
            },
          ],
          dateRetain: [
            {
              required: true,
              message: "Ngày tạm nghỉ không được để trống",
              trigger: "change",
            },
          ],
        },
      },
      isSaveConfigCamera:false,
      listAppPlusConfig: [],
    };
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    getListCamera(id) {
      SupperPlusService.getListCamera(id).then((response) => {
        this.plusCamList = response.data;
        this.comparePlusCamList = JSON.parse(JSON.stringify(response.data));
      })
    },
    getAppPlusConfig(id){
      SupperPlusService.getAppPlusConfig(id).then((response) => {
        this.listAppPlusConfig = response.data.data
      })
    },
    handleChangePlusConfig(row){
      let data = {
        key: row.key,
        value: row.showConfig,
      }
      SupperPlusService.saveAppPlusConfig(this.idEmployeeEdit, data).then((response) => {
        if (response.data.data === true){
          NotifyMessage.leftCornerNotificationSuccess("Cập nhật thành công!");
        } else {
          NotifyMessage.leftCornerNotificationError("Cập nhật thất bại");
        }
      })

    },
    //Quan trọng, cấm xóa!
    getVariableFromSon(bool){
      this.isSaveConfigCamera = bool;
    },
    handleSettingCame(row) {
      this.showSettingCamera = true;
      this.idCamera = row.idCamera;
      this.idPlus = this.idEmployeeEdit;
      this.cameraName = row.cameraName;

    },
    triggerAvatarUpload() {
      if (this.$refs.upload) {
        this.$refs.upload.$el.querySelector('.el-upload__input').click();
      }
    },
    triggerQrUpload() {
      if (this.$refs.uploadQrBank) {
        this.$refs.uploadQrBank.$el.querySelector('.el-upload__input').click();
      }
    },
    closeDialog() {
      this.activeTabName = "infoTab";
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      if (this.$refs.uploadQrBank) {
        this.$refs.uploadQrBank.clearFiles();
      }
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView = "";
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb = "";
      this.imageUrlPreview = "";
      this.qrUrlPreview = "";
      this.$refs["formAllTabEmployee"].resetFields();
      this.$emit("dialog-close");
      this.showPicutreInitial = true;
    },
    async saveNewListCam() {
      let cameraByUserRequestList = [];
      for (let i = 0; i < this.plusCamList.length; i++) {
        let cameraSetting = {
          idUserCam: this.idEmployeeEdit,
          idCamera: this.plusCamList[i].idCamera,
          nameCam: this.plusCamList[i].cameraName,
          typeUser: "plus",
          active: this.plusCamList[i].active
        }
        cameraByUserRequestList.push(cameraSetting)
      }
      let data = {
        cameraByUserRequestList: cameraByUserRequestList
      }
      await StudentService.saveSettingCameraPlus(data).then((res) => {
        console.log(res.data)
      }).catch((error) => {
        console.log(error)
      })
    },
    //click when click button
    closeDialogByButton(fromData) {
      if(this.isSaveConfigCamera){
        this.$confirm('Bạn vẫn chưa lưu lại các thiết lập!', 'Cảnh báo', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(()=>{
          this.handleClose(fromData)
        })
      }else {
        this.handleClose(fromData)
      }
    },
    handleClose(fromData){
      this.activeTabName = "infoTab";
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      if (this.$refs.uploadQrBank) {
        this.$refs.uploadQrBank.clearFiles();
      }
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView = "";
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb = "";
      this.imageUrlPreview = "";
      this.qrUrlPreview = "";
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      this.showUpload = true;
      this.showUploadQr = true;
      this.showPicutreInitial = true;
      if (this.$parent && this.$parent.handleCurrentChangeAfter) {
        this.$parent.handleCurrentChangeAfter();
      }
    },
    getEmployeeById(idEmployee) {
      this.idEmployeeEdit = idEmployee;
      SupperPlusService.getPlusById(idEmployee)
          .then((response) => {
            this.formAllTabEmployee.updateEmployeeMainInfoRequest = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getEmployeeByIdAndIdSchool(idEmployee, idSchool) {
      this.formAllTabEmployee.idSchool = idSchool;
      this.idEmployeeEdit = idEmployee;
      EmployeeDataService.getEmployeeByIdAndIdSchool(idEmployee, idSchool)
          .then((response) => {
            let a = (this.formAllTabEmployee.updateEmployeeMainInfoRequest =
                response.data.data);
            console.log(a);
          })
          .catch((err) => {
            console.log(err);
          });
    },
    async submitForm(fromData) {
      await this.saveNewListCam();
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;

          let iconArrayPlus1 = this.plusIconAppUpdate.plusIconUpdate1;
          let iconArrayPlus2 = this.plusIconAppUpdate.plusIconUpdate2;
          let iconArrayPlus = iconArrayPlus1.concat(iconArrayPlus2);
          this.formAllTabEmployee.appIconPlusRequestList = iconArrayPlus;
          let formDatas = new FormData();

          formDatas.append(
              "idEmployee",
              this.formAllTabEmployee.updateEmployeeMainInfoRequest.id
          );
          formDatas.append(
              "fileName",
              this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatar
          );
          if (this.fileAvatar != null && this.fileAvatar != "") {
            formDatas.append("multipartFile", this.fileAvatar);
            SupperPlusService.uploadEditAvatar(formDatas)
                .then(() => {
                  this.updateEmployee(fromData);
                })
                .catch((err) => {
                  NotifyMessage.leftCornerNotificationError(err.response.data.message);
                });
          } else {
            this.updateEmployee(fromData);
          }
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

    /**
     * cập nhật nhân viên
     */
    updateEmployee(fromData) {
      if (this.fileQrBank) {
        let formQr = new FormData();
        formQr.append("idEmployee", this.formAllTabEmployee.updateEmployeeMainInfoRequest.id);
        formQr.append("multipartFile", this.fileQrBank);
        EmployeeDataService.uploadQrBank(formQr);
      }
      SupperPlusService.updatePlus(this.idEmployeeEdit, this.formAllTabEmployee)
          .then((response) => {
            NotifyMessage.leftCornerNotificationSuccess(response.data.message);
            this.handleClose(fromData);
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError(err.response.data.message);
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButton = false;
            }, 500);
          });
    },
    uploadEditAvatar(formData) {
      EmployeeDataService.uploadEditAvatar(formData)
          .then((res) => {
            console.log(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
    },
    clickNameInitial(name, data) {
      if (data == "fullName") {
        this.showButtonClick = false;
        this.editInfoPlus= "Thông tin plus " + name
      } else if (data == "noFullName") {
        this.showButtonClick = true;
        this.editInfoPlus= "Sửa thông tin plus " + name
      }
    },
    getAllAccountType() {
      EmployeeDataService.getAccountType()
          .then((response) => {
            this.accountTypeList = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    tabPlusIconMethod(id) {
      SupperPlusService.findIconPlusUpdate(id)
          .then((resp) => {
            this.plusIconAppUpdate.plusIconUpdate1 =
                resp.data.data.appIconPlusResponseList1;
            this.plusIconAppUpdate.plusIconUpdate2 =
                resp.data.data.appIconPlusResponseList2;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    pushDataToCheckBoxDepartment() {
      let a = this.formAllTabEmployee.tabDepartmentInEmployee.filter(
          (item) => item.checkDepartment == true
      );
      this.formAllTabEmployee.tabDepartmentRequestList = a;
    },
    selectionMultiProfessional() {
      let a = this.formAllTabEmployee.tabProfessionalInEmployee.filter(
          (item) => item.checkIsClass == true
      );
      this.formAllTabEmployee.tabProfessionalRequestList = a;
    },
    toggleUpload(file, fileList) {
      this.fileList = fileList;
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.fileAvatar = file.raw;
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatar = this.fileAvatar.name;
      this.imageUrlPreview = URL.createObjectURL(file.raw);
    },
    toggleUploadQr(file, fileList) {
      this.showPicutreInitial = false;
      this.showUploadQr = false;
      this.fileQrBank = file.raw;
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.imgBank = file.name;
      this.fileQrList = fileList;
      this.qrUrlPreview = URL.createObjectURL(file.raw);
    },
    handleRemove() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.showUpload = true;
      this.fileAvatar = null;
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatar = null;
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.avatarView = null;
      this.imageUrlPreview = "";
    },
    handleRemoveQr() {
      if (this.$refs.uploadQrBank) {
        this.$refs.uploadQrBank.clearFiles();
      }
      this.showUploadQr = true;
      this.fileQrBank = null;
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.imgBank = null;
      this.formAllTabEmployee.updateEmployeeMainInfoRequest.qrCodeWeb = null;
      this.qrUrlPreview = "";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },


  },

};
</script>
<style>
.hideUpload > div {
  display: none;
}
</style>
<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/ .update-employee-plus-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/ .update-employee-plus-dialog .el-dialog__header {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

/deep/ .update-employee-plus-dialog .el-dialog__body {
  padding: 18px 22px 8px;
}

/deep/ .update-employee-plus-dialog .el-dialog__footer {
  padding: 10px 22px 20px;
}

/deep/ .update-employee-plus-dialog .el-dialog__title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

.update-employee-plus-content {
  padding: 4px 0 6px;
}

.employee-plus-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px;
}

/deep/ .update-employee-plus-tabs > .el-tabs__header {
  margin-bottom: 18px;
}

/deep/ .el-form-item__label {
  font-family: Inter, Arial, Helvetica, sans-serif;
  color: #475569;
  font-weight: 600;
}

/deep/ .el-form-item {
  margin-bottom: 16px;
}

/deep/ .el-input__inner {
  border-radius: 10px;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.update-employee-plus-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

.table-icon-1 {
  width: 32%;
  margin-left: 15%;
  display: inline-block;
}

.table-icon-2 {
  width: 32%;
  margin-right: 15%;
  float: right;
}

.checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .btn-cancel,
/deep/ .btn-save {
  min-width: 110px;
  border-radius: 10px;
}

/* Redesigned Information Tab Style rules */
.common-info-tab {
  & > .el-row {
    display: flex;
    align-items: stretch;
  }

  /deep/ .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 16px;
    
    .el-form-item__label {
      width: 100% !important;
      text-align: left;
      float: none;
      line-height: 20px;
      padding: 0 0 6px 0;
      font-size: 13px;
      font-weight: 600;
      color: #475569;
    }
    
    .el-form-item__content {
      margin-left: 0 !important;
      line-height: normal;
    }
  }
}

.profile-sidebar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  box-sizing: border-box;
}

.profile-avatar-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  
  .profile-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-trigger-area {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    gap: 4px;
    transition: all 0.2s ease;

    i {
      font-size: 20px;
      font-weight: bold;
    }

    &:hover {
      background: #f1f5f9;
      color: #3b82f6;
    }
  }

  .avatar-actions-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 23, 42, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    opacity: 0;
    transition: opacity 0.25s ease;
    z-index: 10;
  }

  &:hover .avatar-actions-overlay {
    opacity: 1;
  }

  .avatar-action-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    outline: none;
    background: #ffffff;
    color: #0f172a;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: scale(1.1);
    }

    &.edit-btn:hover {
      background: #3b82f6;
      color: #ffffff;
    }

    &.delete-btn:hover {
      background: #ef4444;
      color: #ffffff;
    }
  }
}

.qr-bank-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qr-container-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  
  .qr-bank-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 6px;
    box-sizing: border-box;
  }
}

.qr-trigger-area {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  transition: all 0.2s ease;

  i {
    font-size: 20px;
    font-weight: bold;
  }

  &:hover {
    background: #f1f5f9;
    color: #10b981;
  }
}

.qr-actions-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  opacity: 0;
  transition: opacity 0.25s ease;
  z-index: 10;
}

.qr-container-wrap:hover .qr-actions-overlay {
  opacity: 1;
}

.profile-code-section {
  text-align: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 12px;
}

.profile-code-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: block;
}

.profile-code-value {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-top: 2px;
  font-family: monospace;
}

.profile-status-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-divider {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.status-radio-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  
  /deep/ .el-radio-button {
    width: 100%;
    margin: 0;
    
    .el-radio-button__inner {
      width: 100%;
      border-radius: 10px !important;
      border: 1px solid #e2e8f0;
      box-shadow: none !important;
      padding: 10px 15px;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.2s ease;
      color: #64748b;
    }
    
    &.is-active .el-radio-button__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: #ffffff;
    }
  }
}

.status-date-wrap {
  background: #fffbeb;
  border: 1px solid #fef3c7;
  border-radius: 12px;
  padding: 12px;
  margin-top: 4px;
}

.info-section-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  margin-bottom: 20px;
  height: 100%;
  box-sizing: border-box;
}

.card-inner-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #3b82f6;
    font-size: 16px;
  }
}

.parent-card {
  .card-inner-title i {
    color: #10b981;
  }
}

.gender-radio-group {
  width: 100%;
  display: flex;
  
  /deep/ .el-radio-button {
    flex: 1;
    
    .el-radio-button__inner {
      width: 100%;
      border-radius: 10px !important;
      padding: 10px 0;
      text-align: center;
      border: 1px solid #e2e8f0;
      color: #64748b;
      font-weight: 500;
    }
    
    &.is-active .el-radio-button__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: #ffffff;
    }
  }
}
</style>
